<template>
  <div class="render-list">
    <CommonHeader :curNavIndex="curNavIndex"></CommonHeader>
    <div id="wrapper" class="iscroll-list work-list painter-detail">
      <div id="scroller">
        <div id="J_PullDown" class="ui-refresh-down" style="display:none;"><span class="refresh-down-label"></span></div>
        <ul id="thelist">
          <img class="loading-img" src="../../static/img/loading.gif">
        </ul>
        <div id="J_PullUp" class="ui-refresh-up" style="display:none;"><span class="refresh-up-label">More</span><img class="pull-up-img" src="../../static/img/loading.gif"></div>
      </div>
    </div>
    <div id="J_ErrorTip" class="error-tip"></div>
    <CommonFooter></CommonFooter>
  </div>
</template>
<script>
  import axios from 'axios';
  import {API_LIST} from '../utils/config';
  import CommonHeader from './Header';
  import CommonFooter from './Footer';
  import {getLanguage} from '../utils/language';
  import {loaded, renderData} from '../utils/refresh';

  export default {
    name: 'PainterDetail',
    components: {
      CommonHeader,
      CommonFooter
    },
    data () {
      return {
        curNavIndex: 0,
        errorImgUrl: '../../static/img/error.png',
        painterId:this.$route.params.painterId || '1',
        pageInfo:{page: 1, pageSize: 5}
      }
    },
    methods: {
      getWorkList: function(){
        let navLanguage = (navigator.language || navigator.browserLanguage).toLowerCase();

        if(navLanguage.split('-')[0] === 'zh'){
          navLanguage = 'en';
        }else{
          navLanguage = 'zh';
        }

        let curLanguage = getLanguage() !== undefined ?  getLanguage() : navLanguage;

        var formData = JSON.stringify(Object.assign(this.pageInfo,{painter_id: this.painterId, language: curLanguage}));

        axios.post(API_LIST.painterDetail, JSON.parse(formData))
          .then(res => {
            if (res.data.status.error_code === 0) {
              let currentPage = res.data.pageinfo.cur_page;

              //上拉标识符(首屏，非首屏的标识符)
              if(currentPage > 1){
                $('#J_PullUp').find('.pull-up-img').hide();
              }

              let strHtml = '';

              if(currentPage === 1){
                if(res.data.bizobj.introduction === ''){
                  strHtml = `<div class="painter-name">${res.data.bizobj.name}</div>`;
                }else{
                  strHtml = `<div class="painter-name">${res.data.bizobj.name}</div><div class="painter-desc">${res.data.bizobj.introduction.replace(/\r\n/g,"<br/>").replace(/\s+/g, "　")}</div>`;
                }
              }

              for(let item of res.data.bizobj.workList){
                strHtml = strHtml + (`<li>
                  <div class="item-content">
                  <a href="/#/workDetail/${item.workId}">
                  <div class="work-img"><img src="${item.imgUrl}" onerror="this.src='${this.errorImgUrl}';"/></div>
                  <div class="work-name">${item.workName}</div>
                  <div class="work-info"><span>${item.painterName}</span><span>${item.time}</span></div>
                  <div class="work-info"><span>${item.material}</span><span>${item.type}</span></div>
                  <div class="work-info">${item.size}</div>
                  </a>
                  </div>
                  </li>`);
              }

              if(currentPage > 1){
                $('#thelist').append(strHtml);
              }else{
                $('#thelist').html(strHtml);
              }

              setTimeout(() => {myScroll.refresh();}, 200);

              $('#J_CommonFooter').show();

              this.pageInfo.page = currentPage + 1;

              if(this.pageInfo.page > res.data.pageinfo.max_page || res.data.pageinfo.max_page === 1){
                $('#J_PullUp').hide()
              }else{
                $('#J_PullUp').find('.refresh-up-label').html('More');

                $('#J_PullUp').show()
              }
            }else{
              $('#J_PullUp').hide();

              // if(res.data.pageinfo.cur_page > 1){
              //   $('#thelist').append('<div class="empty-data">'+ res.data.status.error_msg + '</div>');
              // }else{
              //   $('#thelist').html('<div class="empty-data">'+ res.data.status.error_msg +'</div>');
              // }

              setTimeout(() => {myScroll.refresh();}, 200);

              $('#J_CommonFooter').show();
            }
          }).catch(err => {
            console.log(err);
          });
      }
    },
    created: function(){
      setTimeout(loaded, 200);
    },
    mounted: function(){
      renderData(this.getWorkList);
    }
  }
</script>

<style scoped>
#wrapper{top:7rem;}
</style>



// WEBPACK FOOTER //
// PainterDetail.vue?7573bf2a